var Cookies = require('js-cookie');
var {AmpersandApp: productCatalogApp, AmpersandView} = require('catalog/libs');

var HPEConstants = require('../../../base/hpe.constants');

var template = require('../templates/hpe.productlist.hitselect.template.tpl');
var HitsCollectionView = require('./hpe.productlist.utilitybar.hit.view');


/**
 * hit select view
 */
var HitsSelectView = AmpersandView.extend({
    template: template,
    bindings: {
        'model.labelView': {
            type: 'text',
            hook: 'hits-label'
        },
        'model.hitsUIVisible': {
            type: 'booleanClass',
            selector: '.product-list-utility-bar-hitselect',
            name: 'hide',
            invert: true
        }
    },

    subviews: {
        hitSelector: {
            selector: '#hitselect-selector',
            waitFor: 'model.hits',
            prepareView: function(el) {
                return new HitsCollectionView({
                    el: el,
                    collection: this.model.hits
                });
            }
        }
    },

    /**
     * events
     */
    events: {
        'change select': 'onHitCountToggle'
    },

    initialize: function() {

    },
    /**
     * handle hit count toggle change
     *
     */
    onHitCountToggle: function(e) {

        e.preventDefault();

        //save value to  model
        this.model.hitCount = e.target.value;

        //update/save the cookie
        Cookies.set(HPEConstants.catalog.HIT_COUNT_COOKIE, this.model.hitCount);

        //broadcast change result of select
        productCatalogApp.trigger(HPEConstants.catalog.VIEW_UPDATE_REQUEST, {
            'type': 'hitchange',
            'value': this.model.hitCount
        });
    }
});

module.exports = HitsSelectView;
